// ------------------------------------------------------------------------------
// BulkRadioGroup
// author: mudas
// created: 2025/6/26
// ------------------------------------------------------------------------------

import React, { FC } from 'react';
import { Radio, RadioGroupProps } from 'antd';

import styles from './BulkRadioGroup.module.css';

export interface IProps extends RadioGroupProps {
  columns?: number;
}

const BulkRadioGroup: FC<IProps> = ({ columns = 2, className, ...otherProps }) => {
  return (
    <Radio.Group
      className={styles('bulk-radio-group', className)}
      style={{ gridTemplateColumns: '1fr '.repeat(columns) }}
      {...otherProps}
    />
  );
};

export default BulkRadioGroup;
